// import { useEffect } from "react";
import Login from "./Login";
import SignUp from "./SignUp";
import Home from "./Home";
import Admin from "./Admin";
import { useEffect,useState } from "react";
import { Route,Routes } from "react-router-dom";


function App() {
  const [User,SetUser]=useState([])
  const [planes,SetPlanes]=useState([])
  function fetching1(){
    fetch("https://flask-api-dlzd.onrender.com/users")
    .then(resp=>resp.json())
    .then(data=>SetUser(data))
  }
  useEffect(()=>fetching1(),[])
  const userEmails=User.map((user)=>user.email)
  function fetching2(){
    fetch("https://flask-api-dlzd.onrender.com/aircrafts")
    .then(resp=>resp.json())
    .then(data=>SetPlanes(data))
  }
  useEffect(()=>fetching2(),[planes])
  function handleDeleteMessage(id){
    const delete_plane=planes.filter((plane)=>plane.id!==id)
    SetPlanes(delete_plane)
  }
  return (
    
    <Routes>
     <Route path="/" element={<Login userEmails={userEmails}/>}/>
     <Route path="/signup" element={<SignUp userEmails={userEmails}/>}/>
     <Route path="/home/*" element={<Home planes={planes} />}/>
     <Route path="/admin" element={<Admin planes={planes} handleDeleteMessage={handleDeleteMessage}/>}/>
    </Routes>
  );
}

export default App;
